export default state => state.category?.details?.loyaltyBenefit?.type;
